import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import ActionForm from '@/mixins/ActionForm'
import PedidoController from "@/shared/controllers/pedido/PedidoController";

const name = 'ResumoSequencia'
export default {
  name,
  mixins: [ActionForm],

  components: {
    'g-button' : gButton,
    "g-form" : gForm
  },

  props: {

  },

  mounted () {

    this.$isLoading(true)
      PedidoController.gerarNovoPedido(this.$store.state.infosOrcamento).requisicao
      .then(res => {
        this.$isLoading(false)
        this.PedidoId = res.data.data
        if(res.data.code == 200){
          this.getOrcamentoSequencia()
        }
      }).catch(() => this.$isLoading(false))

    
   
  },

  updated () { },

  data () {
    return {
      Colunas : [
        //Campo dos dados , nome que aparece na página
        {field: 'codigoExterno', header: 'Orçamento', width: '120px', ordena: true},
        {field: 'produto', header: 'Produto', width: '120px', ordena: true},
        {field: 'tipoFluxoOrcamentoEnumTexto', header: 'Tipo', width: '350px', ordena: true},
        {field: 'numeroSequenciaLote', header: 'Sequência', width: '100px', ordena: true},
        {field: 'orcamentoSequenciaEnum', header: 'Status', width: '100px', ordena: true}
      ],
      SequenciaArray: [],

    }
  },

  methods: {
    getOrcamentoSequencia(){
        PedidoController.GetOrcamentoSequencia(this.$route.params.id).requisicao
        .then((res => {
          this.SequenciaArray = res.data.data
        }))

    },
    voltar(){
      this.$router.push(`/gerar-novo-pedido-orcamento`);
    },
    Continuar(){
      this.$router.push(`/gerar-novo-pedido/${this.PedidoId}/info-cliente-pedido`)
    }
  }

};